import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  TokenResponse,
  AuthRequest,
  IAdminTokenPayload,
  EMR_API,
  CRM_API,
  IEMRLayout
} from '@care-portals/api-interfaces';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getDomainFromLocation } from '@care-portals/shared';

const COOKIE_TOKEN_KEY = 'care-portals-token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private AUTH_ENDPOINT = environment.auth.baseUrl;

  constructor(
    public http: HttpClient,
    public router: Router,
    public cookie: CookieService
  ) {}

  public login(authRequest: AuthRequest): Observable<TokenResponse> {
    return this.http
      .post<TokenResponse>(this.AUTH_ENDPOINT + CRM_API.auth.base, authRequest)
      .pipe(
        catchError(err => {
          console.error(err);
          throw new Error('Failed to login: ' + err);
        })
      );
  }

  logout() {
    this.cookie.set(COOKIE_TOKEN_KEY, '', -1, '/', getDomainFromLocation()); // need this because delete sometimes is not working
    return true;
  }

  public saveToken(token: string): void {
    const payload: IAdminTokenPayload = this.decodeTokenPayload(token);
    // payload.exp is a number so remove '(Number.parseInt(payload.exp.toString()' ?
    const expiry = payload
      ? new Date(Number.parseInt(payload.exp.toString(), 10) * 1000)
      : 7;
    this.cookie.set(
      COOKIE_TOKEN_KEY,
      token,
      expiry,
      '/',
      getDomainFromLocation()
    );
  }

  public getToken(): string {
    const token = this.cookie.get(COOKIE_TOKEN_KEY);

    const tokenData = this.decodeTokenPayload(token);

    if (tokenData && tokenData.exp) {
      if (Date.now() >= Number(tokenData.exp) * 1000) {
        return null;
      } else {
        return token;
      }
    }
  }

  private decodeTokenPayload(token: String): IAdminTokenPayload {
    let payload;
    if (token) {
      payload = token.split('.')[1];
      payload = window.atob(payload);
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  ///////////////////////
  ///  USER FUNCTIONS
  //////////////////////
  getUser(): Observable<IAdminTokenPayload> {
    try {
      return this.http.get<IAdminTokenPayload>(
        this.AUTH_ENDPOINT + EMR_API.users.base + EMR_API.users.getCurrent
      );
    } catch (error) {
      console.error(error);
      throw new Error('Failed to get user: ' + error);
    }
  }

  ///////////////////////
  ///  ADMIN APP
  //////////////////////
  getAppLayouts(): Observable<IEMRLayout[]> {
    return this.http.get<IEMRLayout[]>(
      this.AUTH_ENDPOINT + EMR_API.app.base + EMR_API.app.layout + '?app=emr'
    );
  }
}
